// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"txtqbB","isMobile":"DKBWzP"};